import { useSelector } from 'react-redux';
import { DashboardWrapper } from 'components';
import ReadOnlyContainer from 'components/UtilityComponents/PageLayout/components/ReadOnlyContainer';
import CaseManagerRouter from './CaseManagerRouter';

export default function ConnectRouter({ loading }) {
	const userType = useSelector((state) => state.user.user.type);

	if (userType !== 'case-manager') {
		return <ReadOnlyContainer baseRoute='connect' />;
	}

	return (
		<DashboardWrapper loading={loading}>
			<CaseManagerRouter />
		</DashboardWrapper>
	);
}
